export default __webpack_public_path__ + "static/media/spa-image-05.95503bd6.jpg";